<template>
  <div class=" section_sectionWrapper">
    <div class="module-worldView">
      <div class="title"></div>
      <div class="worldView-cont">
        <div class="word-box">
          <div v-for="i in 9" :key="i" :class="'world-' + i" class="icon" @click="handleIcon(i)">
          </div>
        </div>
      </div>
    </div>

    <!-- 点击显示不同的详情图 -->
    <div class="d-model model" v-if="dModel">
      <div class="d-detail">
        <img :src="require('../../assets/img/worldView/w-' + imgIndex + '.png')" alt="" srcset="">
        <div class="d-close" @click="handleClose"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',


  data() {
    return {
      imgIndex: 1,
      dModel: false
    }
  },
  methods: {
    handleIcon(item) {
      this.imgIndex = item
      this.dModel = true
    },
    handleClose() {
      this.dModel = false
    }
  },
  watch: {


  }
}
</script>
<style lang="scss" scoped>
.module-worldView {
  height: 100%;
  width: 100%;
  position: relative;
  // width: 1920px;
  // height: 1080px;

  .title {
    
    width: 325px;
    height: 105px;
    background-size: 100% 100%;
    position: absolute;
    top: 105px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url("../../assets/img/worldView/title.png");
  }

  .worldView-cont {
    width: 1471px;
    height: 751px;
    background-size: 100% 100%;
    background-image: url("../../assets/img/worldView/bg.png");
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top:60%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .word-box {
      position: relative;
      width: 100%;
      height: 100%;

      .icon {
        width: 240px;
        height: 240px;
        position: absolute;

        &:hover {
          cursor: url("../../assets/img/worldView/search-icon.png"), pointer;
        }
      }

      .world-1 {
        top: 40px;
        left: 368px;
      }

      .world-2 {
        top: 250px;
        left: 40px;
      }

      .world-3 {
        bottom: 100px;
        left: 260px;
      }

      .world-4 {
        bottom: 0;
        left: 460px;
      }

      .world-5 {
        top: 227px;
        right: 568px;
      }

      .world-6 {
        bottom: 120px;
        right: 220px;
      }

      .world-7 {
        top: 250px;
        right: 80px;
      }

      .world-8 {
        top: 0;
        right: 420px;
      }
      .world-9 {
        bottom: 0;
        right: 480px;
      }
    }
  }
}

.d-model {
  width: 100%;
  height: 100%;
  position: fixed;

  .d-detail {
    width: 100%;
    height: 100%;

    position: relative;

    .d-close {
      width: 60px;
      height: 60px;
      position: absolute;
      right: 24px;
      top: 24px;
      z-index: 1;
      cursor: pointer;
      background-size: 100% 100%;
      background-image: url("../../assets/img/worldView/close.png");
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

@media (max-width: 1024px) {
  .d-model img {
    width: 100%;
    height: 100%;
    object-fit: contain !important;
  }
}
@media screen and (max-width: 1200px) {
  .module-worldView {
    .worldView-cont {
        top: 55% !important;
    }
  }
}
@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .module-worldView {
    .title {
      width: 288px !important;
      height: 94px !important;
    }

    .worldView-cont {
      width: 1177px !important;
      height: 600px !important;
      transform: translate(-50%, -55%) !important;
      top:65% !important;

      .icon {
        width: 195px !important;
        height: 195px !important;

      }

      .world-1 {
        left: 274px !important;
      }

      .world-2 {
        top: 200px !important;
      }

      .world-3 {
        bottom: 70px !important;
        left: 208px !important;

      }

      .world-4 {
        left: 368px !important;
      }

      .world-5 {
        top: 182px !important;
        right: 450px !important;
      }

      .world-6 {
        bottom: 60px !important;
        right: 190px !important;
      }

      .world-7 {
        top: 200px !important;
        right: 60px !important;
      }

      .world-8 {

        right: 320px !important;
      }
      .world-9 {
      
        right: 388px !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/worldView.vue